{
  "auth.changePassword.confirmPasswordLabel": "تأكيد كلمة المرور الجديدة",
  "auth.changePassword.confirmPasswordPlaceholder": "أعد إدخال كلمة المرور الجديدة",
  "auth.changePassword.currentPasswordLabel": "كلمة المرور الحالية",
  "auth.changePassword.currentPasswordPlaceholder": "أدخل كلمة المرور الحالية",
  "auth.changePassword.error.currentPasswordIncorrect": "كلمة المرور الحالية غير صحيحة.",
  "auth.changePassword.error.passwordMismatch": "كلمتا المرور غير متطابقتين.",
  "auth.changePassword.error.samePassword": "يجب أن تكون كلمة المرور الجديدة مختلفة عن كلمة المرور الحالية.",
  "auth.changePassword.headerTitle": "تغيير كلمة المرور",
  "auth.changePassword.newPasswordLabel": "كلمة المرور الجديدة",
  "auth.changePassword.newPasswordPlaceholder": "أدخل كلمة المرور الجديدة",
  "auth.changePassword.submit": "تغيير كلمة المرور",
  "auth.changePassword.subtitle": "حسابك يستخدم كلمة مرور مؤقتة. يرجى تعيين كلمة مرور جديدة للمتابعة.",
  "auth.changePassword.success": "تم تغيير كلمة المرور بنجاح.",
  "auth.changePassword.title": "تغيير كلمة المرور",
  "auth.forgotPassword.emailLabel": "البريد الإلكتروني",
  "auth.forgotPassword.emailPlaceholder": "you@example.com",
  "auth.forgotPassword.goBack": "رجوع",
  "auth.forgotPassword.headerTitle": "نسيت كلمة المرور",
  "auth.forgotPassword.sendCode": "إرسال الرمز",
  "auth.forgotPassword.subtitle": "أدخل عنوان البريد الإلكتروني المرتبط بحسابك وسنرسل لك رمزاً لإعادة تعيين كلمة المرور.",
  "auth.forgotPassword.title": "نسيت كلمة المرور",
  "auth.login.emailLabel": "البريد الإلكتروني",
  "auth.login.emailPlaceholder": "you@example.com",
  "auth.login.error.expiredOtp": "انتهت صلاحية الرمز. يرجى طلب رمز جديد.",
  "auth.login.error.invalidEmail": "يرجى إدخال عنوان بريد إلكتروني صالح.",
  "auth.login.error.invalidToken": "رابط الدعوة غير صالح أو منتهي الصلاحية.",
  "auth.login.error.wrongPassword": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
  "auth.login.forgotPassword": "نسيت كلمة المرور؟",
  "auth.login.headerTitle": "مرحباً بعودتك",
  "auth.login.heading": "مرحباً بعودتك",
  "auth.login.noSms": "لا نرسل رموزاً عبر الرسائل القصيرة.",
  "auth.login.otpLabel": "الرمز المؤقت",
  "auth.login.otpPlaceholder": "أدخل الرمز المرسل إلى بريدك الإلكتروني",
  "auth.login.otpSent": "تم إرسال الرمز إلى بريدك الإلكتروني.",
  "auth.login.passwordLabel": "كلمة المرور",
  "auth.login.passwordPlaceholder": "أدخل كلمة المرور",
  "auth.login.sendOtp": "إرسال الرمز",
  "auth.login.submit": "تسجيل الدخول",
  "auth.login.subtitle": "سجّل الدخول للوصول الآمن إلى طلبك.",
  "auth.login.tabOtp": "رمز البريد الإلكتروني",
  "auth.login.tabPassword": "كلمة المرور",
  "auth.login.title": "تسجيل الدخول",
  "auth.otp.error.expired": "انتهت صلاحية الرمز. يرجى طلب رمز جديد.",
  "auth.otp.error.invalid": "الرمز الذي أدخلته غير صحيح.",
  "auth.otp.getHelp": "الحصول على مساعدة",
  "auth.otp.headerTitle": "التحقق",
  "auth.otp.heading": "تحقق من بريدك الإلكتروني",
  "auth.otp.resend": "إعادة الإرسال",
  "auth.otp.resendCooldown": "إعادة الإرسال خلال {seconds} ثانية",
  "auth.otp.resendPrompt": "لم تستلم الرمز؟",
  "auth.otp.submit": "تسجيل الدخول",
  "auth.otp.subtitle": "أدخل الرمز المكوّن من 6 أرقام المرسل إلى بريدك الإلكتروني",
  "auth.otp.title": "التحقق",
  "auth.otpVerification.didntGetCode": "لم تستلم الرمز؟",
  "auth.otpVerification.error.expiredCode": "انتهت صلاحية هذا الرمز. يرجى طلب رمز جديد.",
  "auth.otpVerification.error.invalidCode": "الرمز الذي أدخلته غير صحيح.",
  "auth.otpVerification.getHelp": "احصل على المساعدة",
  "auth.otpVerification.headerTitle": "التحقق",
  "auth.otpVerification.resendCode": "إعادة الإرسال",
  "auth.otpVerification.submit": "تسجيل الدخول",
  "auth.otpVerification.subtitle": "أدخل الرمز المكوّن من 6 أرقام المُرسَل إلى بريدك الإلكتروني",
  "auth.otpVerification.title": "تحقق من بريدك الإلكتروني",
  "auth.resetPassword.confirmPasswordLabel": "تأكيد كلمة المرور الجديدة",
  "auth.resetPassword.confirmPasswordPlaceholder": "أعد إدخال كلمة المرور الجديدة",
  "auth.resetPassword.contactSupport": "تواصل مع الدعم",
  "auth.resetPassword.needHelp": "تحتاج مساعدة؟",
  "auth.resetPassword.newPasswordLabel": "كلمة المرور الجديدة",
  "auth.resetPassword.newPasswordPlaceholder": "أدخل كلمة المرور الجديدة",
  "auth.resetPassword.submit": "إعادة تعيين كلمة المرور",
  "auth.resetPassword.subtitle": "أنشئ كلمة مرور قوية لم تستخدمها من قبل.",
  "auth.resetPassword.success": "تم إعادة تعيين كلمة المرور بنجاح.",
  "auth.resetPassword.title": "إعادة تعيين كلمة المرور",
  "auth.resetPassword.verifyEmail.contactSupport": "تواصل مع الدعم",
  "auth.resetPassword.verifyEmail.needHelp": "تحتاج مساعدة؟",
  "auth.resetPassword.verifyEmail.heading": "تحقق من بريدك الإلكتروني",
  "auth.resetPassword.verifyEmail.submit": "تحقق من الرمز",
  "auth.resetPassword.verifyEmail.subtitle": "أدخل الرمز المكوّن من 6 أرقام المرسل إلى بريدك الإلكتروني للتحقق من هويتك.",
  "auth.register.alreadyHaveAccount": "هل لديك حساب بالفعل؟ تسجيل الدخول",
  "auth.register.alreadyHaveAccountLabel": "تسجيل الدخول",
  "auth.register.alreadyHaveAccountPrefix": "هل لديك حساب بالفعل؟",
  "auth.register.emailLabel": "البريد الإلكتروني",
  "auth.register.emailReadOnly": "تم ملء بريدك الإلكتروني مسبقاً من دعوتك ولا يمكن تغييره.",
  "auth.register.error.invalidInvite": "رابط الدعوة غير صالح أو تم استخدامه بالفعل.",
  "auth.register.error.passwordComplexity": "يجب أن تحتوي كلمة المرور على أحرف كبيرة وصغيرة وأرقام.",
  "auth.register.error.passwordTooLong": "يجب ألا تتجاوز كلمة المرور 32 حرفاً.",
  "auth.register.error.passwordTooShort": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل.",
  "auth.register.firstNameLabel": "الاسم الأول",
  "auth.register.firstNamePlaceholder": "الاسم الأول",
  "auth.register.firstNameRequired": "الاسم الأول مطلوب.",
  "auth.register.headerTitle": "إنشاء حساب",
  "auth.register.infoPanelStep1Desc": "قدّم تفاصيل الممثل القانوني المفوّض عن شركتك.",
  "auth.register.infoPanelStep1Title": "الممثل القانوني ومعلومات التواصل",
  "auth.register.infoPanelStep2Desc": "شارك بيانات التسجيل الرسمية كما تظهر في المستندات القانونية.",
  "auth.register.infoPanelStep2Title": "معلومات العمل الأساسية",
  "auth.register.infoPanelStep3Desc": "حدّد ما تبيعه وأكّد اعتماداتك الامتثالية.",
  "auth.register.infoPanelStep3Title": "معلومات المنتجات والامتثال",
  "auth.register.infoPanelStep4Desc": "أعدّ بياناتك المصرفية بأمان لاستقبال المدفوعات.",
  "auth.register.infoPanelStep4Title": "التسوية المالية",
  "auth.register.infoPanelStep5Desc": "أخيراً، حدّد هوية علامتك التجارية ومواردها المرئية.",
  "auth.register.infoPanelStep5Title": "العلامة التجارية والتعريب",
  "auth.register.infoPanelTitle": "إليك ما نحتاجه لمراجعة طلبك",
  "auth.register.lastNameLabel": "اسم العائلة",
  "auth.register.lastNamePlaceholder": "اسم العائلة",
  "auth.register.lastNameRequired": "اسم العائلة مطلوب.",
  "auth.register.passwordHint": "8–32 حرفاً، يجب أن تحتوي على حرف كبير وحرف صغير ورقم على الأقل.",
  "auth.register.passwordLabel": "إنشاء كلمة مرور",
  "auth.register.passwordPlaceholder": "أنشئ كلمة مرور",
  "auth.register.privacyLink": "سياسة الخصوصية",
  "auth.register.questionsText": "هل لديك أسئلة حول متطلبات الطلب؟",
  "auth.register.submit": "إنشاء حساب",
  "auth.register.subtitle": "قم بإعداد حسابك لبدء عملية طلب التوريد.",
  "auth.register.termsLink": "شروط الخدمة",
  "auth.register.termsMid": " و",
  "auth.register.termsPrefix": "بالنقر على \"إنشاء حساب\"، فإنك توافق على ",
  "auth.register.termsText": "بالنقر على \"إنشاء حساب\"، فإنك توافق على {termsLink} و{privacyLink} لـ AladdinMiles.",
  "auth.register.title": "إنشاء حساب",
  "common.back": "السابق",
  "common.cancel": "إلغاء",
  "common.changeFile": "تغيير",
  "common.clearSearch": "مسح البحث",
  "common.close": "إغلاق",
  "common.confirm": "تأكيد",
  "common.contactSupport": "تواصل مع الدعم",
  "common.disabled": "معطّل",
  "common.error.generic": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  "common.error.network": "خطأ في الشبكة. يرجى التحقق من اتصالك.",
  "common.error.unauthorized": "ليس لديك صلاحية لتنفيذ هذا الإجراء.",
  "common.error.uploadRequired": "تحميل الملف مطلوب",
  "common.footer.copyright": "© 2026 AladdinMiles",
  "common.footer.helpCenter": "مركز المساعدة",
  "common.footer.privacyPolicy": "سياسة الخصوصية",
  "common.footer.termsOfService": "شروط الخدمة",
  "common.goToDashboard": "الانتقال إلى لوحة التحكم",
  "common.language.ar": "العربية",
  "common.language.en": "الإنجليزية",
  "common.language.zh": "الصينية المبسطة",
  "common.learnMore": "اعرف المزيد",
  "common.loading": "جارٍ التحميل…",
  "common.logout": "تسجيل الخروج",
  "profile.title": "الملف الشخصي",
  "profile.fullName": "الاسم الكامل",
  "profile.email": "البريد الإلكتروني",
  "profile.role": "الدور",
  "profile.vendorStatus": "حالة الطلب",
  "profile.vendorStatus.pending_registration": "في انتظار التسجيل",
  "profile.vendorStatus.pending_application": "في انتظار الطلب",
  "profile.vendorStatus.pending_review": "قيد المراجعة",
  "profile.vendorStatus.approved": "موافق عليه",
  "profile.vendorStatus.rejected": "مرفوض",
  "profile.vendorStatus.update_required": "يتطلب تحديثاً",
  "profile.section.account": "الحساب",
  "profile.section.preferences": "التفضيلات",
  "profile.submittedDocuments": "المستندات المقدمة",
  "profile.changePassword": "تغيير كلمة المرور",
  "profile.changePassword.successToast": "تم تغيير كلمة المرور بنجاح. يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.",
  "profile.changePassword.oldPasswordLabel": "كلمة المرور القديمة",
  "profile.changePassword.oldPasswordPlaceholder": "أدخل كلمة المرور القديمة",
  "profile.changePassword.submit": "إعادة تعيين كلمة المرور",
  "profile.getHelp": "الحصول على المساعدة",
  "common.next": "التالي",
  "common.noCountriesFound": "لا توجد دول",
  "common.notifications": "الإشعارات",
  "common.optional": "اختياري",
  "common.qrNotScanned": "لم يتم مسح رمز QR بعد",
  "common.qrScanned": "تم مسح رمز QR",
  "common.relativeTime.daysFuture": "خلال {n} أيام",
  "common.relativeTime.daysPast": "منذ {n} أيام",
  "common.relativeTime.hoursFuture": "خلال {n} ساعات",
  "common.relativeTime.hoursPast": "منذ {n} ساعات",
  "common.relativeTime.justNow": "الآن",
  "common.relativeTime.minutesFuture": "خلال {n} دقائق",
  "common.relativeTime.minutesPast": "منذ {n} دقائق",
  "common.relativeTime.secondsFuture": "خلال {n} ثوانٍ",
  "common.relativeTime.secondsPast": "منذ {n} ثوانٍ",
  "common.required": "مطلوب",
  "common.rescanQR": "مسح مجدداً",
  "common.save": "حفظ",
  "common.saveDraft": "حفظ المسودة",
  "common.scanQR": "مسح رمز QR",
  "common.search": "بحث",
  "common.searchCountriesPlaceholder": "البحث عن دول…",
  "common.selectFile": "اختر ملفاً",
  "common.selectOption": "اختر خياراً",
  "common.submit": "إرسال",
  "common.table.empty.description": "لا توجد حاليًا بيانات لعرضها في هذا الجدول.",
  "common.table.empty.title": "لا تتوفر بيانات",
  "common.table.showing": "عرض {from} إلى {to} من {total}",
  "common.uploadError": "فشل الرفع. يرجى المحاولة مرة أخرى.",
  "common.uploadSuccess": "تم الرفع بنجاح",
  "common.uploading": "جارٍ الرفع…",
  "common.view": "عرض",
  "countryDialCodePicker.a11y.code": "رمز الدولة: {flag} {dialCode}",
  "countryDialCodePicker.title": "اختر رمز الدولة",
  "countryPicker.a11y.country": "الدولة: {name}",
  "countryPicker.title": "اختر الدولة",
  "dev.logout": "DEV: تسجيل الخروج",
  "emptyState.description": "لا توجد عناصر لعرضها.",
  "emptyState.title": "لا يوجد شيء بعد",
  "errorState.description": "حدث خطأ غير متوقع، يرجى المحاولة مرة أخرى.",
  "errorState.retry": "حاول مرة أخرى",
  "errorState.title": "حدث خطأ",
  "fileUpload.a11y.uploadFile": "رفع ملف",
  "fileUpload.acceptedFormats": "PDF أو PNG أو JPG (بحد أقصى {maxSize} ميجابايت)",
  "fileUpload.acceptedFormatsNoSize": "PDF أو PNG أو JPG",
  "fileUpload.andAttachFiles": "وإرفاق الملفات",
  "fileUpload.clickToUpload": "انقر للرفع",
  "fileUpload.uploadFailed": "فشل الرفع. انقر للمحاولة مرة أخرى.",
  "fileUpload.viewDocument": "عرض المستند",
  "filePreview.error": "تعذّر تحميل المعاينة",
  "filePreview.errorDescription": "تعذّر عرض الملف. يرجى المحاولة مرة أخرى.",
  "filePreview.loading": "جارٍ تحميل المعاينة…",
  "imageUpload.a11y.uploadImages": "تحميل الصور",
  "imageUpload.addMore": "إضافة المزيد من الصور",
  "imageUpload.clickToUpload": "انقر للرفع",
  "imageUpload.maxImages": "PNG أو JPG (بحد أقصى {count} صور)",
  "imageUpload.orDragAndDrop": "أو اسحب وأفلت",
  "imageUpload.removeImage": "إزالة الصورة {index}",
  "imageUpload.uploading": "جارٍ رفع الصور…",
  "infoCard.approval.description": "تتم مراجعة الطلبات عادةً خلال 1–2 يوم عمل بعد التقديم.",
  "infoCard.approval.title": "موافقة سريعة",
  "infoCard.assist.description": "فريق التسجيل متاح من 9 صباحًا حتى 6 مساءً بتوقيت CST لمساعدتك.",
  "infoCard.assist.title": "هل تحتاج مساعدة؟",
  "infoCard.secure.description": "بياناتك مشفّرة ولن تتم مشاركتها مع أطراف خارجية دون موافقتك.",
  "infoCard.secure.title": "آمن وسري",
  "invite.landing.invalidLink": "رابط الدعوة غير صالح أو منتهياً. يُرجى التواصل مع مسؤولك.",
  "invite.landing.invalidLinkTitle": "دعوة غير صالحة",
  "invite.landing.mobileOption.hint": "سنعرض لك رمز QR لمسحه ضوئيًا",
  "invite.landing.mobileOption.title": "تنزيل التطبيق الجوال",
  "invite.landing.mobileOption.titleShort": "تنزيل التطبيق",
  "invite.landing.or": "أو",
  "invite.landing.qrModal.subtitle": "امسح رمز QR أدناه بهاتفك",
  "invite.landing.qrModal.title": "تنزيل تطبيق AladdinMiles",
  "invite.landing.title": "لقد تلقيتم دعوة",
  "invite.landing.verifying": "جارٍ التحقق من دعوتك…",
  "invite.landing.webOption.title": "المتابعة عبر الويب",
  "l10n.dashboard.discardChanges": "تجاهل التغييرات",
  "l10n.dashboard.empty": "لم يتم العثور على إدخالات.",
  "l10n.dashboard.language.ar": "العربية",
  "l10n.dashboard.language.en": "الإنجليزية",
  "l10n.dashboard.language.zh-CN": "الصينية المبسطة",
  "l10n.dashboard.saveChanges": "حفظ التغييرات",
  "l10n.dashboard.title": "إدارة الترجمة",
  "language.ar": "العربية",
  "language.en": "English",
  "language.switcher.label": "اللغة",
  "language.zh-CN": "中文",
  "multiSelectPicker.allCategories": "جميع الفئات",
  "multiSelectPicker.allIndustries": "جميع القطاعات",
  "multiSelectPicker.noResults": "لا توجد نتائج",
  "multiSelectPicker.remove": "إزالة",
  "multiSelectPicker.saveSelection": "حفظ الاختيار",
  "multiSelectPicker.searchCategories": "ابحث عن اسم الفئة",
  "multiSelectPicker.searchIndustries": "ابحث عن اسم القطاع",
  "multiSelectPicker.selectAll": "اختر الكل",
  "multiSelectPicker.selectedCategories": "الفئات المختارة",
  "multiSelectPicker.selectedCategoriesCount": "لقد اخترت {count} فئات منتجات",
  "multiSelectPicker.selectedIndustries": "القطاعات المختارة",
  "multiSelectPicker.selectedIndustriesCount": "لقد اخترت {count} قطاعات",
  "multiSelectPicker.switchToChinese": "切换 Switch to Chinese",
  "multiSelectPicker.switchToEnglish": "ABC Switch to English",
  "notFound.description": "الصفحة التي تبحث عنها غير موجودة أو غير متاحة.",
  "notFound.goHome": "العودة إلى الرئيسية",
  "notFound.heading": "الصفحة غير موجودة",
  "notFound.screenTitle": "غير موجود",
  "placeholder.activity.description": "سترى هنا التحديثات المتعلقة بطلبك وحسابك.",
  "placeholder.activity.title": "التحديثات",
  "placeholder.home.description": "ستظهر لوحة المعلومات الخاصة بك هنا.",
  "placeholder.home.title": "الرئيسية",
  "placeholder.profile.description": "ستظهر إعدادات ملفك الشخصي هنا.",
  "placeholder.profile.title": "الملف الشخصي",
  "portal.dashboard.allInvitationsSent": "جميع الدعوات المُرسلة",
  "portal.dashboard.applications": "الطلبات",
  "portal.dashboard.applicationsSubmitted": "الطلبات المقدمة",
  "portal.dashboard.approved": "موافق عليه",
  "portal.dashboard.filter.custom": "مخصص",
  "portal.dashboard.filter.last24Hours": "آخر 24 ساعة",
  "portal.dashboard.filter.last30Days": "آخر 30 يومًا",
  "portal.dashboard.filter.last7Days": "آخر 7 أيام",
  "portal.dashboard.invitations": "الدعوات",
  "portal.dashboard.invited": "مدعو",
  "portal.dashboard.newInvitations": "دعوات جديدة",
  "portal.dashboard.overview": "نظرة عامة",
  "portal.dashboard.pendingReview": "قيد المراجعة",
  "portal.dashboard.recentApplications": "الطلبات الأخيرة",
  "portal.dashboard.rejected": "مرفوض",
  "portal.dashboard.resentInvitations": "دعوات معاد إرسالها",
  "portal.dashboard.reviewApplication": "مراجعة الطلب",
  "portal.dashboard.subtitle": "ملخص الأنشطة عبر طلبات الموردين والدعوات.",
  "portal.dashboard.table.companyName": "اسم الشركة",
  "portal.dashboard.table.lastActivity": "آخر نشاط",
  "portal.dashboard.table.primaryContact": "جهة الاتصال الرئيسية",
  "portal.dashboard.table.primaryIndustry": "الصناعة الرئيسية",
  "portal.dashboard.table.status": "الحالة",
  "portal.dashboard.viewAllApplications": "عرض جميع الطلبات",
  "portal.nav.activity": "التحديثات",
  "portal.nav.adminUsers": "مستخدمو الإدارة",
  "portal.nav.application": "الطلب",
  "portal.nav.applications": "الطلبات",
  "portal.nav.home": "الرئيسية",
  "portal.nav.invitations": "الدعوات",
  "portal.nav.overview": "نظرة عامة",
  "portal.nav.profile": "الملف الشخصي",
  "preVetting.draftSaved": "تم حفظ المسودة.",
  "preVetting.goBack": "رجوع",
  "preVetting.step1.contactEmail": "البريد الإلكتروني للعمل",
  "preVetting.step1.contactPhone": "رقم الهاتف",
  "preVetting.step1.contactPhonePlaceholder": "+86 000 0000 0000",
  "preVetting.step1.department": "القسم",
  "preVetting.step1.error.idDocumentRequired": "وثيقة الهوية مطلوبة.",
  "preVetting.step1.error.invalidEmail": "يرجى إدخال عنوان بريد إلكتروني صالح.",
  "preVetting.step1.error.invalidPhone": "يرجى إدخال رقم هاتف صالح بتنسيق E.164.",
  "preVetting.step1.error.wechatQrNull": "تعذّر تحليل رمز WeChat. يرجى المسح مجدداً.",
  "preVetting.step1.idDocument": "رفع وثيقة الهوية",
  "preVetting.step1.idType": "نوع وثيقة الهوية",
  "preVetting.step1.idType.nationalId": "بطاقة الهوية الوطنية الصينية",
  "preVetting.step1.idType.passport": "جواز السفر",
  "preVetting.step1.idType.other": "أخرى",
  "preVetting.step1.legalNameChinese": "الاسم القانوني (بالصينية)",
  "preVetting.step1.legalNameEnglish": "الاسم القانوني (بالإنجليزية)",
  "preVetting.step1.nationality": "الجنسية",
  "preVetting.step1.nextLabel": "إضافة معلومات النشاط التجاري",
  "preVetting.step1.roleInCompany": "المسمى الوظيفي",
  "preVetting.step1.shortLabel": "الممثل القانوني",
  "preVetting.step1.subtitle": "يرجى تقديم تفاصيل الممثل القانوني المفوض لشركتك.",
  "preVetting.step1.title": "الممثل القانوني ومعلومات الاتصال",
  "preVetting.step1.wechatQr": "رمز QR الخاص بـ WeChat",
  "preVetting.step2.businessLicense": "الرخصة التجارية",
  "preVetting.step2.companyNameArabic": "اسم الشركة (بالعربية)",
  "preVetting.step2.companyNameArabicOptional": "اسم الشركة (بالعربية) (اختياري)",
  "preVetting.step2.companyNameChinese": "اسم الشركة (بالصينية)",
  "preVetting.step2.companyNameEnglish": "اسم الشركة (بالإنجليزية)",
  "preVetting.step2.error.businessLicenseRequired": "وثيقة الرخصة التجارية مطلوبة.",
  "preVetting.step2.error.taxNumberLength": "يجب أن يكون من 15 إلى 20 حرفاً أو رقماً.",
  "preVetting.step2.error.unifiedCodeFormat": "يجب أن يحتوي رمز الائتمان الاجتماعي الموحد على أرقام وأحرف كبيرة فقط.",
  "preVetting.step2.error.unifiedCodeLength": "يجب أن يكون 18 حرفاً أو رقماً بالضبط.",
  "preVetting.step2.hqAddress": "عنوان المقر الرئيسي",
  "preVetting.step2.hqCity": "المدينة",
  "preVetting.step2.hqPostalCode": "الرمز البريدي",
  "preVetting.step2.nextLabel": "إضافة معلومات المنتج والامتثال",
  "preVetting.step2.sectionHqAddress": "عنوان المقر الرئيسي",
  "preVetting.step2.shortLabel": "معلومات العمل",
  "preVetting.step2.subtitle": "قدّم المعلومات القانونية الرسمية لشركتك وتفاصيل التسجيل التجاري.",
  "preVetting.step2.taxRegistrationNumber": "رقم التسجيل الضريبي",
  "preVetting.step2.title": "المعلومات التجارية الأساسية",
  "preVetting.step2.unifiedSocialCreditCode": "رمز الائتمان الاجتماعي الموحد",
  "preVetting.step3.addCategory": "إضافة فئة",
  "preVetting.step3.addIndustry": "إضافة صناعة",
  "preVetting.step3.ceMarking": "علامة CE",
  "preVetting.step3.ceMarkingHint": "الصحة والسلامة والحماية البيئية في الاتحاد الأوروبي",
  "preVetting.step3.ceMarkingOptional": "علامة CE",
  "preVetting.step3.declaration": "أُقرّ بموجب هذا بأن المعلومات المقدمة أعلاه صحيحة ودقيقة، وأن الوثائق المرفقة أصلية. أُدرك أن أي مواد مزيفة ستؤدي إلى تعليق فوري للوصول إلى المنصة.",
  "preVetting.step3.ecoCertHint": "FSC أو GOTS أو التجارة العادلة",
  "preVetting.step3.ecoCertification": "شهادة بيئية",
  "preVetting.step3.ecoCertificationOptional": "شهادة البيئة / الاستدامة",
  "preVetting.step3.error.industryRequired": "يرجى اختيار صناعة واحدة على الأقل.",
  "preVetting.step3.error.subcategoryRequired": "يرجى اختيار فئة منتج واحدة على الأقل.",
  "preVetting.step3.industries": "القطاع التشغيلي (اختر جميع ما ينطبق)",
  "preVetting.step3.industriesHint": "يرجى تحديد صناعة واحدة على الأقل.",
  "preVetting.step3.isoCertHint": "إثبات أنظمة إدارة الجودة",
  "preVetting.step3.isoCertification": "شهادة ISO",
  "preVetting.step3.isoCertificationOptional": "شهادة ISO 9001",
  "preVetting.step3.nextLabel": "إضافة معلومات التسوية المالية",
  "preVetting.step3.productSubcategories": "فئة المنتج (اختر جميع ما ينطبق)",
  "preVetting.step3.productSubcategoriesHint": "يرجى تحديد فئة فرعية واحدة على الأقل.",
  "preVetting.step3.qualityReportHint": "نتائج اختبارات مختبرية حديثة من جهة محايدة",
  "preVetting.step3.qualityTestReport": "تقرير اختبار الجودة",
  "preVetting.step3.qualityTestReportOptional": "تقرير اختبار الجودة",
  "preVetting.step3.sectionCompliance": "الامتثال والشهادات",
  "preVetting.step3.shortLabel": "المنتجات والامتثال",
  "preVetting.step3.subtitle": "أضف فئات المنتجات التي تخطط لبيعها وارفع شهادات الامتثال.",
  "preVetting.step3.title": "المنتجات والامتثال",
  "preVetting.step4.alipay.accountEmail": "البريد الإلكتروني لحساب Alipay",
  "preVetting.step4.alipay.accountHolderName": "اسم صاحب الحساب",
  "preVetting.step4.alipay.isUnderLegalEntityName": "الحساب باسم الكيان القانوني",
  "preVetting.step4.alipay.merchantId": "معرّف تاجر Alipay",
  "preVetting.step4.alipay.qrCode": "رمز QR لتاجر AliPay",
  "preVetting.step4.alipay.settlementCurrency": "عملة التسوية",
  "preVetting.step4.alipay.title": "تفاصيل Alipay",
  "preVetting.step4.bank.accountHolderName": "اسم صاحب الحساب",
  "preVetting.step4.bank.accountNumber": "رقم الحساب",
  "preVetting.step4.bank.bankAddress": "عنوان البنك",
  "preVetting.step4.bank.bankName": "اسم البنك",
  "preVetting.step4.bank.ibanCode": "IBAN",
  "preVetting.step4.bank.isUnderLegalEntityName": "الحساب باسم الكيان القانوني",
  "preVetting.step4.bank.settlementCurrency": "عملة التسوية",
  "preVetting.step4.bank.swiftCode": "رمز SWIFT / BIC",
  "preVetting.step4.bank.title": "تفاصيل البنك",
  "preVetting.step4.bank.withdrawConsent": "سحب موافقة الدفع",
  "preVetting.step4.corporateAccountNote": "يرجى التأكد من أن حسابات الدفع مسجلة باسم الكيان القانوني نفسه.",
  "preVetting.step4.error.alipayRequired": "تفاصيل Alipay مطلوبة عند اختيار Alipay.",
  "preVetting.step4.error.bankRequired": "تفاصيل البنك مطلوبة عند اختيار التحويل البنكي.",
  "preVetting.step4.error.channelRequired": "يرجى اختيار قناة دفع واحدة على الأقل.",
  "preVetting.step4.error.wechatPayRequired": "تفاصيل WeChat Pay مطلوبة عند اختيار WeChat Pay.",
  "preVetting.step4.nextLabel": "إضافة معلومات العلامة التجارية",
  "preVetting.step4.paymentChannels": "قنوات الدفع",
  "preVetting.step4.paymentChannelsHint": "يرجى تحديد قناة دفع واحدة على الأقل.",
  "preVetting.step4.selectChannelsLabel": "اختر قنوات الدفع التي تريد استلام المدفوعات من خلالها",
  "preVetting.step4.shortLabel": "الإعداد المالي",
  "preVetting.step4.subtitle": "يرجى تقديم المعلومات المالية لشركتك لاستلام مدفوعات التسوية بأمان.",
  "preVetting.step4.title": "التسوية المالية",
  "preVetting.step4.wechatPay.accountEmail": "البريد الإلكتروني للحساب",
  "preVetting.step4.wechatPay.accountHolderName": "اسم صاحب الحساب",
  "preVetting.step4.wechatPay.accountType": "نوع الحساب",
  "preVetting.step4.wechatPay.error.qrNull": "تعذّر تحليل رمز WeChat Pay. يرجى المسح مجدداً.",
  "preVetting.step4.wechatPay.merchantId": "معرّف تاجر WeChat Pay",
  "preVetting.step4.wechatPay.qrCode": "رمز QR الخاص بـ WeChat Pay",
  "preVetting.step4.wechatPay.settlementCurrency": "عملة التسوية",
  "preVetting.step4.wechatPay.title": "تفاصيل WeChat Pay",
  "preVetting.step5.businessLogo": "شعار الشركة",
  "preVetting.step5.descriptionArabic": "وصف النشاط التجاري (بالعربية)",
  "preVetting.step5.descriptionArabicOptional": "وصف النشاط التجاري (بالعربية) (اختياري)",
  "preVetting.step5.descriptionEnglish": "وصف النشاط التجاري (بالإنجليزية)",
  "preVetting.step5.error.descriptionTooShort": "يجب أن يحتوي الوصف على 10 أحرف على الأقل.",
  "preVetting.step5.error.logoRequired": "شعار الشركة مطلوب.",
  "preVetting.step5.primaryIndustry": "الصناعة الرئيسية",
  "preVetting.step5.shortLabel": "العلامة التجارية والتعريب",
  "preVetting.step5.shortNameArabic": "الاسم المختصر للعمل (بالعربية)",
  "preVetting.step5.shortNameArabicOptional": "الاسم المختصر للعمل (بالعربية) (اختياري)",
  "preVetting.step5.shortNameEnglish": "الاسم المختصر للعمل (بالإنجليزية)",
  "preVetting.step5.shortNameHint": "سيكون هذا اسمك المعروض في تطبيق AladdinMiles للعملاء.",
  "preVetting.step5.subtitle": "أكمل طلبك من خلال تقديم معلومات علامتك التجارية.",
  "preVetting.step5.title": "العلامة التجارية والترجمة",
  "preVetting.stepOf": "الخطوة {current} من {total}",
  "preVetting.title": "طلب التوريد",
  "preVetting.webSubtitle": "أكمل التفاصيل أدناه وسيقيّم فريقنا طلبك",
  "preVetting.webTitle": "تقدّم لتصبح بائعاً",
  "review.application.activityLog.actions.approved": "وافق على هذا الطلب.",
  "review.application.activityLog.actions.rejected": "رفض هذا الطلب.",
  "review.application.activityLog.actions.requested_updates": "طلب تحديثات على هذا الطلب.",
  "review.application.activityLog.actions.resubmitted": "قدّم الطلب المحدّث.",
  "review.application.activityLog.actions.submitted": "قدّم هذا الطلب.",
  "review.application.activityLog.empty": "لا يوجد نشاط مسجل لهذا الطلب حتى الآن.",
  "review.application.activityLog.title": "سجل النشاط",
  "review.application.activityLog.viewRequest": "عرض الطلب",
  "review.application.activityLogComingSoon": "سجل النشاط قريباً.",
  "review.application.approve": "موافقة",
  "review.application.status.approved": "معتمد",
  "review.application.status.pending_review": "قيد المراجعة",
  "review.application.status.rejected": "مرفوض",
  "review.application.brandingLocalization.description": "اسم العرض وأصول العلامة التجارية.",
  "review.application.brandingLocalization.fields.businessLogo": "شعار الشركة",
  "review.application.brandingLocalization.fields.descriptionArabic": "وصف الشركة (بالعربية)",
  "review.application.brandingLocalization.fields.descriptionEnglish": "وصف الشركة (بالإنجليزية)",
  "review.application.brandingLocalization.fields.shortNameArabic": "الاسم المختصر للشركة (بالعربية)",
  "review.application.brandingLocalization.fields.shortNameChinese": "الاسم المختصر للشركة (بالصينية)",
  "review.application.brandingLocalization.fields.shortNameEnglish": "الاسم المختصر للشركة (بالإنجليزية)",
  "review.application.brandingLocalization.noLogo": "لا يوجد شعار محمل",
  "review.application.brandingLocalization.notProvided": "غير مُقدَّم",
  "review.application.brandingLocalization.title": "العلامة التجارية والتوطين",
  "review.application.businessInformation.description": "التفاصيل الرسمية المسجلة للشركة والمعلومات التشغيلية.",
  "review.application.businessInformation.fields.businessLicense": "الرخصة التجارية",
  "review.application.businessInformation.fields.city": "المدينة",
  "review.application.businessInformation.fields.companyNameArabic": "الاسم القانوني للشركة (عربي)",
  "review.application.businessInformation.fields.companyNameChinese": "الاسم القانوني للشركة (صيني)",
  "review.application.businessInformation.fields.companyNameEnglish": "الاسم القانوني للشركة (إنجليزي)",
  "review.application.businessInformation.fields.postalCode": "الرمز البريدي",
  "review.application.businessInformation.fields.registeredAddress": "عنوان المكتب المسجل",
  "review.application.businessInformation.fields.taxRegistrationNumber": "رقم التسجيل الضريبي",
  "review.application.businessInformation.fields.ussc": "رمز الائتمان الاجتماعي الموحد (USSC)",
  "review.application.businessInformation.notProvided": "غير مُقدَّم",
  "review.application.businessInformation.title": "معلومات العمل",
  "review.application.companyName": "الشركة",
  "review.application.contentComingSoon": "محتوى {name} قريباً.",
  "review.application.edit": "تعديل",
  "review.application.financialSettlement.description": "المعلومات المالية للشركة لأغراض تسوية المدفوعات. بعض الحقول مخفية لأسباب أمنية.",
  "review.application.financialSettlement.fields.accountHolderName": "اسم صاحب الحساب",
  "review.application.financialSettlement.fields.alipayBusinessName": "اسم الشركة المسجل في علي باي",
  "review.application.financialSettlement.fields.alipayEmail": "بريد حساب علي باي",
  "review.application.financialSettlement.fields.alipayMerchantId": "رقم تاجر علي باي",
  "review.application.financialSettlement.fields.alipayQrCode": "رمز QR لدفع علي باي",
  "review.application.financialSettlement.fields.bankAccountNumber": "رقم الحساب البنكي",
  "review.application.financialSettlement.fields.bankAddress": "عنوان البنك",
  "review.application.financialSettlement.fields.bankName": "اسم البنك",
  "review.application.financialSettlement.fields.iban": "IBAN",
  "review.application.financialSettlement.fields.settlementCurrency": "عملة التسوية",
  "review.application.financialSettlement.fields.swiftCode": "كود SWIFT",
  "review.application.financialSettlement.fields.wechatBusinessName": "اسم الشركة المسجل في ويتشات باي",
  "review.application.financialSettlement.fields.wechatEmail": "بريد حساب ويتشات باي",
  "review.application.financialSettlement.fields.wechatMerchantId": "رقم تاجر ويتشات باي",
  "review.application.financialSettlement.fields.wechatQrCode": "رمز QR لدفع ويتشات باي",
  "review.application.financialSettlement.fields.wechatSettlementAccountType": "نوع حساب التسوية",
  "review.application.financialSettlement.notProvided": "غير مُقدَّم",
  "review.application.financialSettlement.sections.alipay": "علي باي",
  "review.application.financialSettlement.sections.bank": "البنك",
  "review.application.financialSettlement.sections.wechatPay": "ويتشات باي",
  "review.application.financialSettlement.showQrCode": "عرض رمز QR",
  "review.application.financialSettlement.title": "التسوية المالية",
  "review.application.legalRepresentative.description": "التفاصيل الشخصية لممثل العمل القانوني",
  "review.application.legalRepresentative.fields.businessEmail": "البريد الإلكتروني",
  "review.application.legalRepresentative.fields.department": "القسم",
  "review.application.legalRepresentative.fields.fullNameChinese": "الاسم الكامل (صيني)",
  "review.application.legalRepresentative.fields.fullNameEnglish": "الاسم الكامل (إنجليزي)",
  "review.application.legalRepresentative.fields.legalId": "هوية الممثل القانوني",
  "review.application.legalRepresentative.fields.nationality": "الجنسية",
  "review.application.legalRepresentative.fields.phoneNumber": "رقم الهاتف",
  "review.application.legalRepresentative.fields.role": "الدور",
  "review.application.legalRepresentative.fields.wechatQr": "رمز الاستجابة السريعة (WeChat)",
  "review.application.legalRepresentative.notUploaded": "لم يتم الرفع",
  "review.application.legalRepresentative.passport": "جواز سفر",
  "review.application.legalRepresentative.passportPlaceholder": "عنصر نائب لصورة جواز السفر",
  "review.application.legalRepresentative.title": "الممثل القانوني وجهة الاتصال",
  "review.application.productCompliance.description": "فئات المنتجات وشهادات الامتثال والصناعات التشغيلية.",
  "review.application.productCompliance.fields.ceMarking": "علامة CE",
  "review.application.productCompliance.fields.ecoCertifications": "شهادات بيئية",
  "review.application.productCompliance.fields.isoCertificate": "شهادة ISO 9001",
  "review.application.productCompliance.fields.operatingCategories": "الفئات التشغيلية",
  "review.application.productCompliance.fields.operatingIndustries": "الصناعات التشغيلية",
  "review.application.productCompliance.fields.qualityTestReports": "تقارير اختبار الجودة",
  "review.application.productCompliance.notProvided": "غير مُقدَّم",
  "review.application.productCompliance.title": "المنتج والامتثال",
  "review.application.productCompliance.viewDocument": "عرض المستند",
  "review.application.reject": "رفض",
  "review.application.rejectionDetails.dateRejected": "تاريخ الرفض",
  "review.application.rejectionDetails.reason": "السبب",
  "review.application.rejectionDetails.rejectedBy": "رُفض بواسطة",
  "review.application.rejectionDetails.viewReason": "سبب الرفض",
  "review.application.requestChanges": "طلب تعديلات",
  "review.application.submittedAt": "تاريخ التقديم",
  "review.application.subtabs.brandingLocalization": "العلامة التجارية",
  "review.application.subtabs.businessInformation": "معلومات العمل",
  "review.application.subtabs.financialSettlement": "التسوية المالية",
  "review.application.subtabs.legalRepresentative": "الممثل القانوني",
  "review.application.subtabs.productCompliance": "المنتج والامتثال",
  "review.application.tabs.activityLog": "سجل النشاط",
  "review.application.tabs.submittedInformation": "المعلومات المقدمة",
  "review.application.undoDecision": "التراجع عن القرار",
  "review.dashboard.empty": "لا توجد طلبات معلقة للمراجعة.",
  "review.dashboard.status.pendingReview": "قيد المراجعة",
  "review.dashboard.title": "طلبات الموردين",
  "review.review.decision.approve": "الموافقة على الطلب",
  "review.review.decision.approveModal.checklist.brandAssets": "أصول العلامة التجارية وبيانات التوطين مكتملة وتستوفي متطلبات السوق",
  "review.review.decision.approveModal.checklist.businessRegistration": "تمت مطابقة تسجيل الشركة ورمز USSC مع السجلات الرسمية",
  "review.review.decision.approveModal.checklist.complianceCertificates": "جميع شهادات الامتثال صالحة وحديثة وتتطابق مع الفئات المقدمة",
  "review.review.decision.approveModal.checklist.financialSettlement": "تم التحقق من بيانات اعتماد التسوية المالية والحساب نشط",
  "review.review.decision.approveModal.checklist.legalIdentity": "تم التحقق من هوية الممثل القانوني مقابل وثائق الهوية المقدمة",
  "review.review.decision.approveModal.checklistNote": "يُرجى إكمال جميع بنود القائمة لتفعيل الموافقة.",
  "review.review.decision.approveModal.confirmApproval": "تأكيد الموافقة",
  "review.review.decision.approveModal.successDescription": "سيتم إخطار هذا المورّد عبر البريد الإلكتروني بأن طلبه قد تمت الموافقة عليه.",
  "review.review.decision.approveModal.successTitle": "تمت الموافقة على المورّد",
  "review.review.decision.approveModal.verificationChecklist": "قائمة التحقق",
  "review.review.decision.description": "اختر قراراً للطلب بأكمله.",
  "review.review.decision.reject": "رفض الطلب",
  "review.review.decision.rejectFieldModal.internalNote": "ملاحظة داخلية",
  "review.review.decision.rejectFieldModal.internalNotePlaceholder": "هذا للرجوع الداخلي فقط ولن يكون مرئيًا للمورد.",
  "review.review.decision.rejectFieldModal.reasonPlaceholder": "لا يتطابق مع السجلات الرسمية.",
  "review.review.decision.rejectFieldModal.rejectedFieldLabel": "الحقل المرفوض",
  "review.review.decision.rejectFieldModal.title": "رفض الحقل المحدد",
  "review.review.decision.rejectModal.reasonForRejection": "سبب الرفض",
  "review.review.decision.rejectModal.reasonPlaceholder": "تفاصيل الشركة غير متسقة عبر المستندات المقدمة.",
  "review.review.decision.rejectModal.rejectedVendor": "المورّد المرفوض",
  "review.review.decision.rejectModal.submitRejection": "تأكيد الرفض",
  "review.review.decision.rejectModal.successDescription": "سيتم إخطار المورّد عبر البريد الإلكتروني بأن طلبه قد تم رفضه.",
  "review.review.decision.rejectModal.successTitle": "تم رفض الطلب",
  "review.review.decision.requestChanges": "طلب التغييرات",
  "review.review.decision.requestChangesModal.addReason": "إضافة سبب",
  "review.review.decision.requestChangesModal.addReasons": "إضافة أسباب",
  "review.review.decision.requestChangesModal.back": "رجوع",
  "review.review.decision.requestChangesModal.fields.alipayBusinessName": "اسم الشركة المسجل في AliPay",
  "review.review.decision.requestChangesModal.fields.alipayMerchantId": "معرّف تاجر AliPay",
  "review.review.decision.requestChangesModal.fields.businessLicense": "الرخصة التجارية",
  "review.review.decision.requestChangesModal.fields.businessLogo": "شعار الشركة",
  "review.review.decision.requestChangesModal.fields.ceMarking": "علامة CE",
  "review.review.decision.requestChangesModal.fields.companyNameEnglish": "اسم الشركة (بالإنجليزية)",
  "review.review.decision.requestChangesModal.fields.descriptionEnglish": "وصف الشركة (بالإنجليزية)",
  "review.review.decision.requestChangesModal.fields.ecoCertifications": "الشهادات البيئية",
  "review.review.decision.requestChangesModal.fields.isoCertificate": "شهادة ISO 9001",
  "review.review.decision.requestChangesModal.fields.legalRepresentativeId": "هوية الممثل القانوني",
  "review.review.decision.requestChangesModal.fields.operatingCategories": "فئات التشغيل",
  "review.review.decision.requestChangesModal.fields.operatingIndustries": "الصناعات التشغيلية",
  "review.review.decision.requestChangesModal.fields.shortNameEnglish": "الاسم المختصر للشركة (بالإنجليزية)",
  "review.review.decision.requestChangesModal.fields.taxRegistrationNumber": "رقم التسجيل الضريبي",
  "review.review.decision.requestChangesModal.fields.unifiedSocialCreditCode": "رمز الائتمان الاجتماعي الموحد",
  "review.review.decision.requestChangesModal.fields.wechatBusinessName": "اسم الشركة المسجل في WeChat Pay",
  "review.review.decision.requestChangesModal.fields.wechatMerchantId": "معرّف تاجر WeChat Pay",
  "review.review.decision.requestChangesModal.fieldsSelected": "الحقول المحددة",
  "review.review.decision.requestChangesModal.noFieldsFound": "لا توجد حقول تطابق بحثك.",
  "review.review.decision.requestChangesModal.noFieldsSelectedHint": "حدد الحقول من الجانب الأيسر التي تحتاج إلى تحديث.",
  "review.review.decision.requestChangesModal.reasonLabel": "السبب",
  "review.review.decision.requestChangesModal.reasonPlaceholder": "اشرح ما يجب تصحيحه...",
  "review.review.decision.requestChangesModal.remove": "إزالة",
  "review.review.decision.requestChangesModal.sendChangeRequest": "إرسال طلب التغيير",
  "review.review.decision.requestChangesModal.step1Subtitle": "الخطوة 1 من 2 (اختر الحقول التي تحتاج إلى تحديث)",
  "review.review.decision.requestChangesModal.step2Subtitle": "الخطوة 2 من 2 (أضف سبباً لكل حقل)",
  "review.review.decision.requestChangesModal.submitRequest": "إرسال الطلب",
  "review.review.decision.requestChangesModal.successDescription": "سيتم إخطار المورّد عبر البريد الإلكتروني بالتغييرات المطلوبة في طلبه.",
  "review.review.decision.requestChangesModal.successTitle": "تم طلب التغييرات",
  "review.review.decision.requestChangesModal.title": "طلب التغييرات",
  "review.review.decision.requestChangesModal.youHaveSelectedCount": "لقد حددت {count} حقلاً",
  "review.review.decision.showDecisions": "عرض القرارات",
  "review.review.decision.title": "قرار الطلب",
  "review.review.editFieldModal.currentValue": "القيمة الحالية",
  "review.review.editFieldModal.newValue": "القيمة الجديدة",
  "review.review.editFieldModal.saveAccept": "حفظ وقبول",
  "review.review.editFieldModal.title": "تعديل الحقل",
  "review.review.fieldState.approved": "موافق عليه",
  "review.review.fieldState.edited": "تم التعديل",
  "review.review.fieldState.reasonModal.dateRejected": "تاريخ الرفض",
  "review.review.fieldState.reasonModal.edit": "تعديل",
  "review.review.fieldState.reasonModal.internalNote": "ملاحظة داخلية",
  "review.review.fieldState.reasonModal.reason": "السبب",
  "review.review.fieldState.reasonModal.rejectedBy": "رُفض بواسطة",
  "review.review.fieldState.reasonModal.title": "سبب الرفض",
  "review.review.fieldState.rejected": "مرفوض",
  "review.review.fieldState.showEdit": "عرض التعديل",
  "review.review.fieldState.showEditModal.currentValue": "القيمة الحالية",
  "review.review.fieldState.showEditModal.dateEdited": "تاريخ التعديل",
  "review.review.fieldState.showEditModal.editedBy": "حُرِّر بواسطة",
  "review.review.fieldState.showEditModal.previousValue": "القيمة السابقة",
  "review.review.fieldState.showEditModal.undoEdit": "التراجع عن التعديل",
  "review.review.fieldState.showEditModal.update": "تحديث",
  "review.review.fieldState.showReason": "عرض السبب",
  "review.review.fieldState.undoDecision": "التراجع عن القرار",
  "review.review.fieldsAudited": "{count} حقول تمت مراجعتها",
  "review.review.reviewCompleted": "اكتملت المراجعة",
  "review.review.sectionProgress": "{current} من {total} أقسام",
  "review.review.title": "مراجعة الطلب",
  "review.review.viewOnly": "للعرض فقط",
  "roles.admin": "مشرف",
  "roles.localizationStaff": "موظف الترجمة",
  "roles.staff": "موظف",
  "roles.superAdmin": "مشرف عام",
  "roles.vendor": "مورد",
  "staff.applications.stats.approved": "طلبات موافق عليها",
  "staff.applications.stats.approvedDesc": "وافق عليها منذ أقل من 24 ساعة",
  "staff.applications.stats.new": "طلبات جديدة",
  "staff.applications.stats.newDesc": "مقدمة منذ أقل من 24 ساعة",
  "staff.applications.stats.rejected": "طلبات مرفوضة",
  "staff.applications.stats.rejectedDesc": "رُفضت منذ أقل من 24 ساعة",
  "staff.applications.subtitle": "مراجعة الطلبات المقدمة ومعالجتها",
  "staff.applications.tabs.all": "الكل",
  "staff.applications.tabs.approved": "موافق عليها",
  "staff.applications.tabs.pending": "قيد المراجعة",
  "staff.applications.tabs.rejected": "مرفوضة",
  "staff.applications.title": "طلبات الموردين",
  "staff.invitations.actions.resendInvite": "إعادة إرسال الدعوة",
  "staff.invitations.actions.sendInvitation": "إرسال دعوة",
  "staff.invitations.detail.activityLog": "سجل النشاط",
  "staff.invitations.detail.activityResent": "أعاد {name} إرسال دعوة إلى هذا المستلم.",
  "staff.invitations.detail.activitySent": "أرسل {name} دعوة إلى هذا المستلم.",
  "staff.invitations.detail.breadcrumb": "الدعوات",
  "staff.invitations.detail.invitationDetails": "تفاصيل الدعوة",
  "staff.invitations.detail.lastInvitationDate": "تاريخ آخر دعوة",
  "staff.invitations.detail.lastInvitedBy": "آخر من أرسل الدعوة",
  "staff.invitations.detail.quickTip": "نصيحة سريعة",
  "staff.invitations.detail.quickTipBody": "إذا لم يتلقَّ المستلم البريد الإلكتروني، اطلب منه التحقق من مجلد البريد العشوائي أو تأكيد صحة عنوان بريده الإلكتروني.",
  "staff.invitations.detail.recipientEmail": "عنوان البريد الإلكتروني للمستلم",
  "staff.invitations.detail.recipientName": "اسم المستلم",
  "staff.invitations.detail.resendCount": "عدد مرات الإعادة",
  "staff.invitations.detail.resendInvite": "إعادة إرسال الدعوة",
  "staff.invitations.detail.sentAgo": "أُرسلت {time} ({date})",
  "staff.invitations.empty": "لم يتم إرسال أي دعوات بعد.",
  "staff.invitations.resend.body": "هل تريد بالتأكيد إعادة إرسال الدعوة إلى {email}؟",
  "staff.invitations.resend.cancel": "إلغاء",
  "staff.invitations.resend.confirm": "تأكيد",
  "staff.invitations.resend.languageLabel": "لغة الدعوة",
  "staff.invitations.resend.languagePlaceholder": "اختر لغة",
  "staff.invitations.resend.success": "تمت إعادة إرسال الدعوة!",
  "staff.invitations.resend.successBody": "تمت إعادة إرسال الدعوة بنجاح.",
  "staff.invitations.resend.title": "إعادة إرسال الدعوة",
  "staff.invitations.send.cancel": "إلغاء",
  "staff.invitations.send.emailLabel": "عنوان البريد الإلكتروني",
  "staff.invitations.send.emailPlaceholder": "أدخل عنوان بريد المورد الإلكتروني",
  "staff.invitations.send.firstNameLabel": "الاسم الأول (اختياري)",
  "staff.invitations.send.firstNamePlaceholder": "أدخل الاسم الأول",
  "staff.invitations.send.inviteVendorSubtitle": "سيتم إرسال رابط تسجيل فريد إلى عنوان البريد الإلكتروني للمستلم",
  "staff.invitations.send.inviteVendorTitle": "دعوة بائع",
  "staff.invitations.send.languageLabel": "لغة الدعوة",
  "staff.invitations.send.languagePlaceholder": "اختر لغة",
  "staff.invitations.send.lastNameLabel": "اسم العائلة (اختياري)",
  "staff.invitations.send.lastNamePlaceholder": "أدخل اسم العائلة",
  "staff.invitations.send.messageLabel": "رسالة شخصية (اختيارية)",
  "staff.invitations.send.messagePlaceholder": "أضف رسالة شخصية إلى الدعوة…",
  "staff.invitations.send.sendInvite": "إرسال الدعوة",
  "staff.invitations.send.submit": "إرسال الدعوة",
  "staff.invitations.send.success": "تم إرسال الدعوة!",
  "staff.invitations.send.successBody": "سيتلقى هذا المستلم بريدًا إلكترونيًا يحتوي على رابط تسجيل فريد لبدء طلبه.",
  "staff.invitations.send.title": "إرسال دعوة",
  "staff.invitations.stats.new": "الدعوات الجديدة",
  "staff.invitations.stats.newDesc": "أُرسلت منذ أقل من 24 ساعة",
  "staff.invitations.stats.total": "إجمالي الدعوات",
  "staff.invitations.stats.totalDesc": "جميع الدعوات التي تم إرسالها",
  "staff.invitations.subtitle": "إدارة وتتبع الدعوات المرسلة إلى الموردين",
  "staff.invitations.table.dateInvited": "تاريخ الدعوة",
  "staff.invitations.table.invitedBy": "أُرسل بواسطة",
  "staff.invitations.table.recipient": "المستلم",
  "staff.invitations.table.showing": "عرض {from} إلى {to} من {total}",
  "staff.invitations.tabs.all": "جميع الدعوات",
  "staff.invitations.tabs.resent": "الدعوات المُعاد إرسالها",
  "staff.invitations.title": "الدعوات",
  "staff.localization.actions.addContent": "إضافة محتوى",
  "staff.localization.actions.filter": "تصفية",
  "staff.localization.actions.sort": "ترتيب",
  "staff.localization.addContent.arabicLabel": "ترجمة عربية",
  "staff.localization.addContent.cancel": "إلغاء",
  "staff.localization.addContent.chineseLabel": "ترجمة صينية",
  "staff.localization.addContent.contentTypeCategories": "فئات المنتجات",
  "staff.localization.addContent.contentTypeIndustries": "قطاعات المنتجات",
  "staff.localization.addContent.contentTypeLabel": "نوع المحتوى",
  "staff.localization.addContent.contentTypeOther": "محتوى آخر",
  "staff.localization.addContent.contentTypePlaceholder": "اختر نوع المحتوى",
  "staff.localization.addContent.englishLabel": "ترجمة إنجليزية",
  "staff.localization.addContent.infoText": "إضافة جميع الترجمات ستنقل هذا المحتوى إلى مكتمل.",
  "staff.localization.addContent.keyLabel": "عنوان المفتاح",
  "staff.localization.addContent.keyPlaceholder": "مثال: common.save",
  "staff.localization.addContent.pending": "معلّق",
  "staff.localization.addContent.submit": "إضافة محتوى",
  "staff.localization.addContent.success": "تمت إضافة المحتوى",
  "staff.localization.addContent.successBody": "تمت إضافة محتوى جديد بنجاح إلى قاموس الترجمة.",
  "staff.localization.addContent.error": "فشل إضافة المحتوى",
  "staff.localization.addContent.errorBody": "حدث خطأ أثناء إضافة المحتوى. يرجى المحاولة مرة أخرى.",
  "staff.localization.addContent.title": "إضافة محتوى جديد",
  "staff.localization.addContent.translationsHeader": "الترجمات",
  "staff.localization.card.completed": "مكتمل",
  "staff.localization.card.lastEdited": "آخر تعديل",
  "staff.localization.card.moreInfo": "المزيد من المعلومات",
  "staff.localization.card.pending": "معلّق",
  "staff.localization.detail.activityLog": "سجل النشاط",
  "staff.localization.detail.activityAction.add": "أضاف ترجمةً",
  "staff.localization.detail.activityAction.edit": "عدّل ترجمةً",
  "staff.localization.detail.activityAction.delete": "حذف ترجمةً",
  "staff.localization.detail.arabic": "العربية",
  "staff.localization.detail.breadcrumb": "الترجمة",
  "staff.localization.detail.chinese": "الصينية",
  "staff.localization.detail.contentType": "نوع المحتوى",
  "staff.localization.detail.contentTypeCategories": "فئات المنتجات",
  "staff.localization.detail.contentTypeIndustries": "قطاعات المنتجات",
  "staff.localization.detail.contentTypeOther": "محتوى آخر",
  "staff.localization.detail.editTranslation": "تعديل الترجمة",
  "staff.localization.detail.editTranslations": "تعديل الترجمات",
  "staff.localization.detail.english": "الإنجليزية",
  "staff.localization.detail.keyTitle": "عنوان المفتاح",
  "staff.localization.detail.language": "اللغة",
  "staff.localization.detail.title": "تفاصيل الترجمة",
  "staff.localization.detail.translation": "الترجمة",
  "staff.localization.filter.statusAll": "الكل",
  "staff.localization.filter.statusCompleted": "مكتمل",
  "staff.localization.filter.statusPending": "معلّق",
  "staff.localization.filter.title": "الحالة",
  "staff.localization.modal.arabicLabel": "ترجمة عربية",
  "staff.localization.modal.cancel": "إلغاء",
  "staff.localization.modal.chineseLabel": "ترجمة صينية",
  "staff.localization.modal.englishLabel": "ترجمة إنجليزية",
  "staff.localization.modal.keyLabel": "عنوان المفتاح",
  "staff.localization.modal.save": "حفظ",
  "staff.localization.modal.saveSuccess": "تم حفظ الترجمة!",
  "staff.localization.modal.saveSuccessBody": "تم تعديل الترجمة بنجاح.",
  "staff.localization.modal.saveError": "فشل الحفظ",
  "staff.localization.modal.saveErrorBody": "حدث خطأ أثناء حفظ الترجمة. يرجى المحاولة مرة أخرى.",
  "staff.localization.modal.title": "تعديل الترجمة",
  "staff.localization.showing": "عرض {from} إلى {to} من {total}",
  "staff.localization.sort.alphaAsc": "تصاعدي (أ-ي)",
  "staff.localization.sort.alphaDesc": "تنازلي (ي-أ)",
  "staff.localization.sort.completionStatus": "حالة الاكتمال",
  "staff.localization.sort.keyName": "اسم المفتاح",
  "staff.localization.sort.lastEdited": "آخر تعديل",
  "staff.localization.sort.sectionAlpha": "أبجديًا",
  "staff.localization.sort.sectionDate": "التاريخ",
  "staff.localization.stats.allContent": "جميع المحتوى",
  "staff.localization.stats.allContentDesc": "جميع المحتوى في القاموس",
  "staff.localization.stats.completed": "الترجمة المكتملة",
  "staff.localization.stats.completedDesc": "محتوى مع ترجمات كاملة",
  "staff.localization.stats.pending": "الترجمة المعلّقة",
  "staff.localization.stats.pendingDesc": "محتوى مع ترجمات مفقودة",
  "staff.localization.subtitle": "إدارة محتوى التطبيق متعدد اللغات",
  "staff.localization.tabs.categories": "فئات المنتجات",
  "staff.localization.tabs.completed": "مكتمل",
  "staff.localization.tabs.industries": "قطاعات المنتجات",
  "staff.localization.tabs.other": "محتوى آخر",
  "staff.localization.tabs.pending": "معلّق",
  "staff.localization.title": "الترجمة",
  "staff.nav.adminUsers": "مستخدمو الإدارة",
  "staff.nav.applications": "الطلبات",
  "staff.nav.home": "الرئيسية",
  "staff.nav.invitations": "الدعوات",
  "staff.nav.localization": "الترجمة",
  "staff.nav.profile": "الملف الشخصي",
  "staff.users.actions.addNewUser": "إضافة مستخدم جديد",
  "staff.users.actions.deactivateUser": "تعطيل المستخدم",
  "staff.users.actions.reactivateUser": "إعادة تفعيل المستخدم",
  "staff.users.deactivate.title": "تعطيل المستخدم",
  "staff.users.deactivate.body": "هل أنت متأكد أنك تريد تعطيل {name}؟ لن يتمكنوا من تسجيل الدخول بعد الآن.",
  "staff.users.deactivate.confirm": "تعطيل",
  "staff.users.deactivate.cancel": "إلغاء",
  "staff.users.deactivate.success": "تم تعطيل المستخدم",
  "staff.users.deactivate.successBody": "تم تعطيل حساب المستخدم ولن يتمكنوا من تسجيل الدخول.",
  "staff.users.reactivate.title": "إعادة تفعيل المستخدم",
  "staff.users.reactivate.body": "هل أنت متأكد أنك تريد إعادة تفعيل {name}؟ سيتمكنون من تسجيل الدخول مرة أخرى.",
  "staff.users.reactivate.confirm": "إعادة تفعيل",
  "staff.users.reactivate.cancel": "إلغاء",
  "staff.users.reactivate.success": "تم إعادة تفعيل المستخدم",
  "staff.users.reactivate.successBody": "تم إعادة تفعيل حساب المستخدم ويمكنهم الآن تسجيل الدخول.",
  "staff.users.detail.activity.empty": "لم يتم العثور على أي نشاط.",
  "staff.users.detail.activity.to": "إلى",
  "staff.users.detail.addedBy": "أضيف بواسطة",
  "staff.users.detail.adminInfo": "المعلومات الإدارية",
  "staff.users.detail.breadcrumb": "مستخدمو الإدارة",
  "staff.users.detail.dateAdded": "تاريخ الإضافة",
  "staff.users.detail.editUser": "تعديل المستخدم",
  "staff.users.detail.emailAddress": "عنوان البريد الإلكتروني",
  "staff.users.detail.firstName": "الاسم الأول",
  "staff.users.detail.languagePreference": "تفضيل اللغة",
  "staff.users.detail.lastActivity": "آخر نشاط",
  "staff.users.detail.lastLogin": "آخر تسجيل دخول {time} ({date})",
  "staff.users.detail.lastModified": "آخر تعديل",
  "staff.users.detail.lastName": "اسم العائلة",
  "staff.users.detail.personalInfo": "المعلومات الشخصية",
  "staff.users.detail.phoneNumber": "رقم الهاتف",
  "staff.users.detail.role": "الدور",
  "staff.users.detail.tabs.activity": "سجل النشاط",
  "staff.users.detail.tabs.profile": "معلومات الملف الشخصي",
  "staff.users.empty": "لم يتم العثور على مستخدمين.",
  "staff.users.modal.addButton": "إضافة مستخدم",
  "staff.users.modal.addSuccess": "تمت إضافة المستخدم الإداري",
  "staff.users.modal.addSuccessBody": "سيتلقى المستخدم بريداً إلكترونياً لتسجيل الدخول إلى حساب AladdinMiles.",
  "staff.users.modal.addTitle": "إضافة مستخدم إداري جديد",
  "staff.users.modal.editSuccess": "تم تحديث المستخدم الإداري",
  "staff.users.modal.editSuccessBody": "تم تحديث ملف المستخدم بنجاح.",
  "staff.users.modal.editTitle": "تعديل المستخدم الإداري",
  "staff.users.modal.rolePlaceholder": "اختر دوراً",
  "staff.users.modal.saveButton": "حفظ التغييرات",
  "staff.users.stats.active": "المستخدمون النشطون",
  "staff.users.stats.activeDesc": "نشطون حالياً على لوحة التحكم",
  "staff.users.stats.disabled": "المستخدمون المعطلون",
  "staff.users.stats.disabledDesc": "لا يمكنهم الوصول إلى لوحة التحكم بعد الآن",
  "staff.users.stats.inactive": "المستخدمون غير النشطين",
  "staff.users.stats.inactiveDesc": "غير نشطين حالياً على لوحة التحكم",
  "staff.users.subtitle": "الوصول إلى أعضاء الفريق وأدوارهم",
  "staff.users.table.lastActivity": "آخر نشاط",
  "staff.users.table.role": "الدور",
  "staff.users.table.status": "الحالة",
  "staff.users.table.user": "المستخدم",
  "staff.users.tabs.active": "نشط",
  "staff.users.tabs.disabled": "معطّل",
  "staff.users.tabs.inactive": "غير نشط",
  "staff.users.title": "مستخدمو الإدارة",
  "successState.description": "تمت العملية بنجاح.",
  "successState.title": "نجاح",
  "toast.a11y.error": "خطأ",
  "toast.a11y.info": "معلومات",
  "toast.a11y.success": "نجاح",
  "ui.checkbox.defaultA11y": "مربع اختيار",
  "ui.login.showcaseA11y": "فتح معرض النماذج",
  "ui.tag.addA11y": "إضافة عنصر جديد",
  "ui.tag.removeA11y": "إزالة {label}",
  "vendor.application.companyInfo.dateApproved": "تاريخ الموافقة",
  "vendor.application.companyInfo.dateSubmitted": "تاريخ التقديم",
  "vendor.application.companyInfo.lastActivity": "آخر نشاط",
  "vendor.application.companyInfo.primaryIndustry": "الصناعة الرئيسية",
  "vendor.application.detail.allFieldsApproved": "تمت الموافقة على جميع الحقول",
  "vendor.application.detail.allFieldsReviewed": "تمت مراجعة جميع الحقول",
  "vendor.application.detail.allFieldsUnderReview": "جميع الحقول قيد المراجعة",
  "vendor.application.detail.fieldRejected": "مرفوض",
  "vendor.application.detail.fieldUpdateRequired": "تحديث مطلوب",
  "vendor.application.detail.fieldUpdated": "تم التحديث",
  "vendor.application.detail.fieldsFlaggedForUpdate": "حقل(حقول) تم تحديدها للتحديث في هذا القسم",
  "vendor.application.detail.makeUpdate": "إجراء تحديث",
  "vendor.application.detail.notUploaded": "لم يتم الرفع",
  "vendor.application.detail.showQrCode": "عرض رمز الاستجابة السريعة",
  "vendor.application.detail.tab.alipay": "علي باي",
  "vendor.application.detail.tab.bank": "البنك",
  "vendor.application.detail.tab.wechatPay": "ويتشات باي",
  "vendor.application.detail.financialSettlement.empty.title": "لا تفاصيل للتسوية",
  "vendor.application.detail.financialSettlement.empty.description": "لم يتم تقديم أي معلومات دفع لهذه الطريقة.",
  "vendor.application.detail.viewDocument": "عرض المستند",
  "vendor.application.detail.viewImage": "عرض الصورة",
  "vendor.application.stages.brandingLocalization": "العلامة التجارية والتوطين",
  "vendor.application.stages.businessInformation": "معلومات النشاط التجاري",
  "vendor.application.stages.completed": "مكتمل",
  "vendor.application.stages.financialSettlement": "التسوية المالية",
  "vendor.application.stages.inProgress": "قيد التنفيذ",
  "vendor.application.stages.legalRepresentative": "الممثل القانوني",
  "vendor.application.stages.notStarted": "لم يبدأ",
  "vendor.application.stages.productCompliance": "المنتج والامتثال",
  "vendor.application.stages.title": "مراحل الطلب",
  "vendor.application.stages.updateRequired": "تحديث مطلوب",
  "vendor.application.subtitle": "ملخص كل قسم من طلبك",
  "vendor.application.update.breadcrumb": "تقديم التحديث",
  "vendor.application.update.confirmBody": "هل أنت متأكد أن المعلومات التي ستقدمها صحيحة؟",
  "vendor.application.update.confirmTitle": "تقديم التحديث",
  "vendor.application.update.correction": "التصحيح",
  "vendor.application.update.correctionPlaceholder": "أدخل القيمة الصحيحة",
  "vendor.application.update.newDocument": "مستند جديد",
  "vendor.application.update.reviewerNote": "ملاحظة المراجع",
  "vendor.application.update.sectionTitle": "تقديم التحديث",
  "vendor.application.update.submitUpdate": "تقديم التحديث",
  "vendor.application.update.successDescription": "تم تقديم تحديثك وسيقوم فريقنا بمراجعته قريبًا.",
  "vendor.application.update.successTitle": "تم تقديم التحديث",
  "vendor.application.update.yesSubmit": "نعم، تقديم",
  "vendor.application.update.yourSubmission": "تقديمك",
  "vendor.approved.body": "تهانينا! تمت الموافقة على طلبك.",
  "vendor.approved.contactSupport": "هل تحتاج إلى مساعدة؟ تواصل مع الدعم.",
  "vendor.approved.credentialsNote": "استخدم البريد الإلكتروني وكلمة المرور اللذين حددتهما أثناء التسجيل.",
  "vendor.approved.portalLink": "الوصول إلى بوابة التاجر",
  "vendor.approved.title": "تمت الموافقة على الطلب",
  "vendor.dashboard.applicationStatus": "حالة طلبك",
  "vendor.dashboard.approvedOn": "تمت الموافقة {date}",
  "vendor.dashboard.approvedState.cta": "انتقل إلى بوابة التاجر",
  "vendor.dashboard.approvedState.description": "تم تفعيل حساب البائع الخاص بك. ستتلقى بريدًا إلكترونيًا ترحيبيًا يتضمن خطوات التهيئة.",
  "vendor.dashboard.approvedState.title": "تهانينا!",
  "vendor.dashboard.emptyState.description": "طلبك قيد المراجعة حاليًا. سنُعلمك فور وجود أي تحديثات.",
  "vendor.dashboard.emptyState.title": "لا شيء للقيام به الآن",
  "vendor.dashboard.nav.activity": "التحديثات",
  "vendor.dashboard.nav.application": "الطلب",
  "vendor.dashboard.nav.home": "الرئيسية",
  "vendor.dashboard.nav.profile": "الملف الشخصي",
  "vendor.dashboard.nextSteps.approved.01.description": "استخدم الزر أعلاه أو الرابط الوارد في بريد الموافقة للوصول إلى بوابة AladdinMiles.",
  "vendor.dashboard.nextSteps.approved.01.title": "تسجيل الدخول إلى بوابة التاجر",
  "vendor.dashboard.nextSteps.approved.02.description": "ابدأ بإضافة المنتجات إلى الكتالوج المنشأ لعملك.",
  "vendor.dashboard.nextSteps.approved.02.title": "إضافة المنتجات",
  "vendor.dashboard.nextSteps.approved.03.description": "استلم الطلبات والفِّ بها في الوقت المناسب لضمان رضا العملاء.",
  "vendor.dashboard.nextSteps.approved.03.title": "تلبية الطلبات",
  "vendor.dashboard.nextSteps.decision.description": "ستتلقى إشعارًا بالنتيجة النهائية.",
  "vendor.dashboard.nextSteps.decision.title": "القرار",
  "vendor.dashboard.nextSteps.review.description": "يتحقق الفريق من المستندات والمعلومات المقدمة",
  "vendor.dashboard.nextSteps.review.title": "المراجعة",
  "vendor.dashboard.nextSteps.title": "الخطوات التالية",
  "vendor.dashboard.nextSteps.validation.description": "يتم التحقق من تسجيل الأعمال وشهادات الامتثال.",
  "vendor.dashboard.nextSteps.validation.title": "التحقق",
  "vendor.dashboard.pendingUpdates.fieldsToUpdate": "{count} حقول للتحديث",
  "vendor.dashboard.pendingUpdates.title": "التحديثات المعلقة",
  "vendor.dashboard.pendingUpdates.noFieldsSpecified": "لم يحدد المراجع الحقول التي تحتاج إلى تحديث. يرجى التواصل معه للاستفسار.",
  "vendor.dashboard.rejectedDocuments.rejected": "مرفوض",
  "vendor.dashboard.rejectedDocuments.title": "المستندات المرفوضة",
  "vendor.dashboard.rejectedDocuments.viewDocument": "عرض المستند",
  "vendor.dashboard.rejectedDocuments.viewReason": "عرض السبب",
  "vendor.dashboard.rejectedOn": "مرفوض {date}",
  "vendor.dashboard.rejectedState.contactSupport": "التواصل مع الدعم",
  "vendor.dashboard.rejectedState.defaultDescription": "لم يتم الموافقة على طلبك. يرجى التواصل مع الدعم للحصول على مزيد من المعلومات.",
  "vendor.dashboard.rejectedState.title": "سبب الرفض",
  "vendor.dashboard.status.approved": "تمت الموافقة",
  "vendor.dashboard.status.notApproved": "غير موافق عليه",
  "vendor.dashboard.status.pending": "قيد الانتظار",
  "vendor.dashboard.status.updateRequired": "تحديث مطلوب",
  "vendor.dashboard.step.approve": "الموافقة",
  "vendor.dashboard.step.review": "المراجعة",
  "vendor.dashboard.step.submitted": "تم الإرسال",
  "vendor.dashboard.submittedOn": "تم الإرسال {date}",
  "vendor.dashboard.subtitle": "إليك آخر مستجدات طلبك.",
  "vendor.dashboard.title": "الرئيسية",
  "vendor.landing.changeLanguage": "تغيير اللغة",
  "vendor.landing.contactSupport": "تواصل مع الدعم",
  "vendor.landing.getStarted": "ابدأ الآن",
  "vendor.landing.needHelp": "هل تحتاج مساعدة؟",
  "vendor.landing.subtitle": "انضم إلى شبكة الموردين الحصرية لـ AladdinMiles واستفد من السوق السعودية. نحن نربط أعمالك بالعملاء المخلصين من خلال تحويل إنفاقهم اليومي إلى مكافآت سفر.",
  "vendor.landing.title": "طوّر أعمالك مع AladdinMiles",
  "vendor.languageSelect.appName": "AladdinMiles",
  "vendor.languageSelect.savePreference": "حفظ التفضيلات",
  "vendor.languageSelect.title": "اختر لغتك المفضلة",
  "vendor.languageSelect.welcomeTo": "مرحبًا بك في",
  "vendor.pendingReview.body": "شكراً لك على تقديم طلبك. سيُكمل فريقنا المراجعة خلال 1–3 أيام عمل. إذا كان لدينا أي أسئلة، سنتواصل معك في أقرب وقت.",
  "vendor.pendingReview.contactTitle": "هل لديك أسئلة أو تحتاج مساعدة؟",
  "vendor.pendingReview.step.approveApplication": "الموافقة على الطلب",
  "vendor.pendingReview.step.completed": "مكتمل",
  "vendor.pendingReview.step.createAccount": "إنشاء حساب",
  "vendor.pendingReview.step.pending": "معلق",
  "vendor.pendingReview.step.rejected": "مرفوض",
  "vendor.pendingReview.step.rejectedApplication": "طلب مرفوض",
  "vendor.pendingReview.step.submitApplication": "تقديم الطلب",
  "vendor.pendingReview.supportEmail": "vendors@aladdinmiles.com",
  "vendor.pendingReview.supportPhone": "+971 4 123 4567",
  "vendor.pendingReview.title": "نحن نراجع طلبك",
  "vendor.rejected.body": "نأسف، لم تتم الموافقة على طلبك في الوقت الحالي. يُرجى مراجعة بريدك الإلكتروني للاطلاع على التفاصيل.",
  "vendor.rejected.title": "لم تتم الموافقة على الطلب",
  "vendor.activity.title": "السجل",
  "vendor.activity.subtitle": "سجل كل تحديث على طلبك",
  "vendor.activity.allActivities": "جميع الأنشطة",
  "vendor.activity.event.applicationApproved.title": "تمت الموافقة على الطلب",
  "vendor.activity.event.applicationApproved.description": "تمت مراجعة طلبك والموافقة عليه.",
  "vendor.activity.event.applicationRejected.title": "لم تتم الموافقة على الطلب",
  "vendor.activity.event.applicationRejected.description": "تمت مراجعة طلبك وعدم الموافقة عليه.",
  "vendor.activity.event.applicationReceived.title": "تم استلام الطلب",
  "vendor.activity.event.applicationReceived.description": "تم تقديم جميع الأقسام الخمسة",
  "vendor.activity.event.updateRequired.title": "مطلوب تحديث",
  "vendor.activity.event.updateRequired.description": "تحتاج بعض الحقول إلى اهتمامك قبل متابعة المراجعة.",
  "vendor.activity.event.updateSubmitted.title": "تم تقديم التحديث",
  "vendor.activity.event.updateSubmitted.description": "تم تقديم تحديثك"
}
